import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResult } from '../shared/types/search-result';
import { Sort } from '../shared/types/sort';
import { StrMarker } from '../shared/types/strMarker';
import { CaliperService, ItemViewService } from '../../../ajs-upgraded-providers';
import { RlFile } from '../../file/shared/rl-file';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private itemViewService: ItemViewService, private caliperService: CaliperService) { }

  foreachOutput(component: any) {
    return new Observable<string>((s) => {
      for (let field in component) {
        if (component[field] instanceof EventEmitter) {
          s.next(field);
        }
      }
    });
  }

  toKeyValue = (values: any[], key: string, value: string): { key: string, value: any }[] => values.map(v => { return { 'key': key ? v[key] : v, 'value': value ? v[value] : v } });

  scroll(element, container) {
    var scrollTo = window['$'](element)[0].offsetTop;// + (window['$'](container)[0].offsetHeight / 2);
    window['$'](container).animate({ scrollTop: scrollTo }, 1000);
  }

  isIframe = () => window.self !== window.top;

  isTouchScreen = () => {

		var isMob=/(iphone|ipod|ipad|android|iemobile|blackberry|bada)/.test(navigator.userAgent.toLowerCase());
		if(!isMob){
			 return navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2; 
		}
		
		return isMob;
	};

  openViewerInNewTab = (content: RlFile) => {
    let url = document.location.href;
    url = url.split('readinglist/')[0] + 'readinglist/citation/' + content.entityId + '/file/viewer';

    this.itemViewService.viewCitation(content.entityId, 'SCID');

    const caliperReferrer = this.caliperService.getCaliperInfo(url, 'SoftwareApplication', content.amazonDisplayFileName, '');
    this.caliperService.send('SCIVFT', 'citation', content.entityId, caliperReferrer);

    this.openInNewTab(url);
  };
  
  openInNewTab = (url?: string) => window.open(url || document.location.href);

  recalcAverage(oldAvg: number = 0, totalElements: number, oldVal: number, newVal: number) : number{
    if (!totalElements) return;
    if (newVal == oldVal) return oldAvg;
    if (newVal == undefined && oldVal != undefined) return (oldAvg * (totalElements + 1) - oldVal) / totalElements;
    if (newVal != undefined && oldVal == undefined) return (oldAvg * (totalElements - 1) + newVal) / totalElements;

    return oldAvg + ((newVal - oldVal) / totalElements);
  }

  sort<T>(arr: T[], ...byFields: string[]): T[] {
    return this.sortComplex(arr, byFields.map(f => new Sort(f, 'asc')));
  }

  sortComplex<T>(arr: T[], byFields: Sort | Sort[]): T[] {
    
    let fields = byFields instanceof Array ? byFields : [byFields]
    return arr.sort((a: T, b: T) => {
      let res = 0;
      for (let i = 0; i < fields.length; i++) {
        let parts = fields[i].field.split('\.');
        let aVal: any = a, bVal: any = b;

        parts.forEach(p => {
          if (aVal && bVal) {
            aVal = aVal[p];
            bVal = bVal[p];
          }
        });

        let compRes = this._compare(aVal, bVal);

        res = res || (fields[i].dir == 'desc' ? -1 * compRes : compRes);
      }

      return res;
    });
  }

  _compare(v1: any, v2: any): number {

    // if v1 > v2 -> positive
    // if v1 < v2 -> negative
    if (v1 == undefined && v2 == undefined) return 0;

    if (v1 == undefined && v2 != undefined) return -1;

    if (v1 != undefined && v2 == undefined) return 1;

    let v1Type: string = typeof (v1);
    let v2Type: string = typeof (v2);

    if (v1Type !== v2Type) console.warn(`trying to compare '${v1}' and '${v2}'. not the same type.`);

    if (typeof (v1) === 'string') return v1 == v2 ? 0 : (v1 > v2 ? 1 : -1);

    if (typeof (v1) === 'number') return v1 - v2;
    
    if (typeof (v1) === 'object') {
      if (v1.constructor.name === 'Date') {
        return v1.getTime() - v2.getTime();
      }
      return v1.compare ? v1.compare(v2) : console.error(`'compare()' not found in object ${v1}`);
    }
  }


  search = (arr: any[], subArrField : string, searchTerm: string, byFields: string[]): SearchResult[] => {
    let res: SearchResult[] = [];
    for (let i = 0; i < arr.length; i++) {
      let item = arr[i];
      for (let j = 0; j < byFields.length; j++) {
        let objectField : string = byFields[j];
        let searchIndex = 0, resultStartIndex;
        while ((resultStartIndex = this.getFieldVal(item, objectField).toLowerCase().indexOf(searchTerm.toLowerCase(), searchIndex)) != -1) {
          res.push(new SearchResult(<string><unknown>i, objectField, new StrMarker(resultStartIndex, searchTerm.length)));
          searchIndex = resultStartIndex + searchTerm.length;
        }
      }

      if(subArrField && item[subArrField]){
        let subRes = this.search(item[subArrField], subArrField, searchTerm, byFields);
        if(subRes.length > 0){
          subRes.forEach(r => r.objectIndex = `${i},${r.objectIndex}`);
          res = res.concat(subRes)
        }
      }

    }
    return res;
  }


  getFieldVal(object: any, field: string) {
    let parts = field.split('\.');
    let value = object;
    parts.forEach(p => {
      value = value && value[p] ? value[p] : "";
    });
    return value;
  }

  findMarkers(word: string, mark: string): StrMarker[] {
    if(!word || !mark) return [];
    let indexOccurence = word.toLowerCase().indexOf(mark.toLowerCase(), 0);
    let strMarkers : StrMarker[] = [];
    while (indexOccurence >= 0) {
      strMarkers.push(new StrMarker(indexOccurence, mark.length, 'semibold-text'));
      indexOccurence = word.toLowerCase().indexOf(mark.toLowerCase(), indexOccurence + 1);
    }
    return strMarkers;
  }

	copyToClipboard(text : string) {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then().catch(e => console.error(e));
  } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = text;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
          // here the magic happens
          try {
            var successful = document.execCommand('copy');
            if (!successful) throw successful;
          } catch (err) {
            window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
          }
          textArea.remove();
      }
	};
}
